const UKRAINE_REGIONS = [
  { code: 'CK', name: 'Cherkasy' },
  { code: 'CH', name: 'Chernihiv' },
  { code: 'CV', name: 'Chernivitsi' },
  { code: 'KR', name: 'Crimea' },
  { code: 'DP', name: 'Dnipropetrovsk' },
  { code: 'DT', name: 'Donetsk' },
  { code: 'IF', name: 'Ivano-Frankivsk' },
  { code: 'KK', name: 'Kharkiv' },
  { code: 'KS', name: 'Kherson' },
  { code: 'KM', name: 'Khmelnytskyi' },
  { code: 'KV', name: 'Kyiv' },
  { code: 'KH', name: 'Kirovohrad' },
  { code: 'LH', name: 'Luhansk' },
  { code: 'LV', name: 'Lviv' },
  { code: 'MY', name: 'Mykolaiv' },
  { code: 'OD', name: 'Odesa' },
  { code: 'PL', name: 'Poltava' },
  { code: 'RV', name: 'Rivne' },
  { code: 'SM', name: 'Sumy' },
  { code: 'TP', name: 'Ternopil' },
  { code: 'VI', name: 'Vinnytsia' },
  { code: 'VO', name: 'Volyn' },
  { code: 'ZK', name: 'Zakarpattia' },
  { code: 'ZP', name: 'Zaporizhzhia' },
  { code: 'ZT', name: 'Zhytomyr' }
];

export default UKRAINE_REGIONS;
